import React, { FC, ReactElement } from 'react';
import styles from './Button.module.scss';
import { Button as MuiButton } from '@mui/material';

export interface ButtonProps {
  onClick: () => void;
  text: string;
  disabled?: boolean;
  icon?: ReactElement;
}

const Button: FC<ButtonProps> = ({ onClick, text, disabled, icon }) => {
  return (
    <MuiButton variant="contained" disableElevation onClick={onClick} className={styles.button} disabled={disabled}>
      {text}
      {icon && icon}
    </MuiButton>
  );
};

export default Button;
